import type { BadgeProps } from "@/components/ui/badge";

type Variant = NonNullable<BadgeProps["variant"]>;

/** Durum kodlarının Türkçe adı ve rengi (API kod döner, metni istemci verir) */
const STATUS: Record<string, [string, Variant]> = {
  // iş
  draft: ["Taslak", "secondary"],
  requested: ["Talep edildi", "warning"],
  accepted: ["Kabul edildi", "default"],
  in_progress: ["Sürüyor", "default"],
  invoiced: ["Faturalandı", "warning"],
  completed: ["Tamamlandı", "success"],
  cancelled: ["İptal", "secondary"],
  disputed: ["İtirazlı", "destructive"],
  expired: ["Süresi doldu", "secondary"],
  // hizmet veren
  pending_review: ["İncelemede", "warning"],
  active: ["Aktif", "success"],
  suspended: ["Askıda", "destructive"],
  rejected: ["Reddedildi", "destructive"],
  closed: ["Kapalı", "secondary"],
  // belge / bildirim / itiraz / talep
  pending: ["Bekliyor", "warning"],
  approved: ["Onaylandı", "success"],
  open: ["Açık", "warning"],
  in_review: ["İnceleniyor", "warning"],
  resolved: ["Çözüldü", "success"],
  upheld: ["Kabul (kaldırıldı)", "destructive"],
  new: ["Yeni", "warning"],
  contacted: ["İletişime geçildi", "default"],
  added_to_catalog: ["Kataloğa eklendi", "success"],
  // ödeme
  paid: ["Ödendi", "success"],
  in_transit: ["Yolda", "default"],
  failed: ["Başarısız", "destructive"],
  succeeded: ["Başarılı", "success"],
  refunded: ["İade edildi", "secondary"],
  charged: ["Tahsil edildi", "success"],
  submitted: ["Gönderildi", "warning"],
  void: ["Geçersiz", "secondary"],
  executed: ["Yürütüldü", "success"],
};

export function statusLabel(code: string | null | undefined): [string, Variant] {
  if (!code) return ["—", "outline"];
  return STATUS[code] ?? [code, "outline"];
}

export const LABELS: Record<string, string> = {
  // hizmet veren türü
  individual: "Bireysel",
  company: "Şirket",
  // belge türleri
  identity_document: "Kimlik",
  selfie: "Selfie",
  police_conduct_certificate: "Sabıka kaydı (Conduct)",
  business_registration: "Şirket sicili",
  vat_registration: "KDV kaydı",
  insurance: "Sigorta",
  trade_license: "Mesleki lisans",
  driving_licence: "Ehliyet",
  other: "Diğer",
  // itiraz nedenleri
  not_done: "Yapılmadı",
  poor_quality: "Kalitesiz",
  overcharged: "Fazla ücret",
  damage: "Hasar",
  no_show: "Gelmedi",
  // bildirim nedenleri
  abuse: "Hakaret / taciz",
  personal_info: "Kişisel bilgi",
  wrong_task: "Yanlış iş",
  discrimination: "Ayrımcılık",
  extortion: "Şantaj",
  illegal: "Yasa dışı",
  // dört göz
  refund_over_threshold: "Eşik üstü iade",
  grant_sensitive_permission: "Hassas yetki verme",
  grant_super_admin: "Super admin yapma",
  // muhasebe
  customer: "Müşteri",
  provider: "Hizmet veren",
  platform: "Poji",
  tax: "Vergi",
  promo: "Promosyon",
  processor: "Stripe",
  commission_revenue: "Komisyon geliri",
  fee_revenue: "Ücret geliri",
  provider_payable: "Hizmet veren alacağı",
  tip: "Bahşiş",
  expense_reimbursement: "Masraf",
  promo_cost: "Promosyon gideri",
  processor_fee: "Stripe ücreti",
  chargeback_loss: "Ters ibraz kaybı",
  refund: "İade",
  payout: "Ödeme",
  vat: "KDV",
  // kaynak
  guest: "Misafir",
  // roller
  owner: "Sahip",
  admin: "Yönetici",
  worker: "Çalışan",
};

export const label = (code: string | null | undefined) => (code ? (LABELS[code] ?? code) : "—");
